import { getEndpoint } from '@/ui/core/config'
import { SignedUrlRequest } from '@/shared/types'
import { nanoid } from 'nanoid'

export interface UploadImageInput {
  file: File
  location: 'entries' | 'events'
  keyPrefix: string
  jwtToken?: string
}

export async function uploadImage(input: UploadImageInput): Promise<string> {
  const { file, location, keyPrefix, jwtToken } = input
  // sanitize the file name
  const fileName = file.name.toLowerCase().replace(/\.(jpg|jpeg|png|heic)$/, '')
  const key = `${keyPrefix}/${nanoid(12)}-${fileName}`

  const signedUrl = await getSignedUrl(
    { location, key, action: 'put' },
    jwtToken,
  )

  try {
    const response = await fetch(signedUrl, {
      method: 'PUT',
      body: file,
    })

    if (!response.ok) {
      throw new Error(`${response.status} is not ok`)
    }

    // Don't like this, but in the optimize bucket it is adding it and
    // haven't found a quicker way to adding this value in the db
    return `${location}/${key}.jpg`
  } catch (err) {
    if (err instanceof Error) {
      throw new Error(`Error putting image ${err.message}`)
    }
    console.error('Error putting image', err)
    throw err
  }
}

export async function getSignedUrl(
  request: SignedUrlRequest,
  jwtToken?: string,
): Promise<string> {
  try {
    const response = await fetch(getEndpoint('images'), {
      method: 'POST',
      body: JSON.stringify(request),
      headers: jwtToken ? { Authorization: jwtToken } : undefined,
    })
    const result = (await response.json()) as { signedUrl: string }
    return result.signedUrl
  } catch (err) {
    console.error('Error uploading image', err)
    throw err
  }
}
